import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import InfoIcon from "@material-ui/icons/Info";
import styles from '../../pages/AgentSearch.scss';

ResultSummary.propTypes = {
  active: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  location: PropTypes.object.isRequired,
};

function ResultSummary(props) {
  const {active, count, location} = props;

  return (
    <div>
      <Typography variant="body1" component="h1" className={styles.summaryH1}>{`${!isNaN(count) && count} ${active === 'agencies' ? 'Agencies' : 'Agents'} in ${location.suburb}, ${location.stateCode} ${location.postcode}`}</Typography>
      <Typography variant="caption" component="p" className={styles.summaryH1}>How are sold &amp; listing counts calculated?<Tooltip enterTouchDelay={0} leaveTouchDelay={0} disableFocusListener title="Sold property counts are based on records available to Cotality that have been matched to an agent or agency on OnTheHouse.com.au within the searched location. Sale and rental listing counts are based on properties advertised on OnTheHouse within the searched location" arrow><InfoIcon className={`ml-2 ${styles.tooltip}`} /></Tooltip></Typography>
    </div>
  );
}

export default ResultSummary;
